<template>
    <div class="workbench-header">
        <div class="left">
            <div class="work-info">
                <div class="work-name"><span>{{name}}</span></div>
                <div class="work-addones">
                    <p v-if="code">编号：{{code}}</p>
                    <p v-if="createTime">生成时间：{{createTime}}</p>
                </div>
            </div>
            <span class="status" v-if="statusText"><span style="vertical-align:middle;">当前订单状态：</span><span style="vertical-align:middle;" class="text">{{statusText}}</span></span>
            <span class="less" v-if="remainTime"><span style="vertical-align:middle;">剩余：</span><span style="vertical-align:middle;" class="time">{{remainTime}}</span><span class="prompt">{{prompt}}</span></span>
        </div>
        <div class="right"><slot/></div>
    </div>
</template>

<script>
export default {
    name: 'workbench-header',
    props: {
        name: {
            type: String,
            default: '头部标题'
        },
        statusText: {
            type: String
        },
        remainTime: {
            type: String
        },
        beforeGoBack: {
            type: Function,
            default () {
                return () => {}
            }
        },
        prompt:{
            type: String,
            default: '提示语'
        },
        code: {
            type: String,
            default: ''
        },
        createTime: {
            type: String,
            default: ''
        }
    },
    methods: {
        async goBack () {
            if (this.beforeGoBack && typeof this.beforeGoBack === 'function') {
                await this.beforeGoBack()
            }
            this.$router.go(-1)
        }
    }
}
</script>

<style lang="scss" scoped>
.workbench-header {
    height: 80px;
    line-height: 80px;
    background: #fff;
    // border:1px solid rgba(216,216,216,1);
    box-sizing: border-box;
    overflow: hidden;
    padding: 0 30px;
    z-index: 100;
    position: relative;
    box-shadow: 1px -1px 10px 1px rgb(234, 234, 234);
    .left {
        float: left;
        height: 78px;
        display: flex;
        .work-info {
            display: flex;
            align-items: center;
            .work-name {
                position: relative;
                color: #606060;
                font-size: 24px;
                font-weight:400;
                align-items: center;
                span {
                    vertical-align: middle;
                }
                &::after {
                    content: '';
                    // position: absolute;
                    display: inline-block;
                    width: 1px;
                    height: 26px;
                    background: #606060;
                    margin-left: 14px;
                    vertical-align: middle;
                }
                @media (max-width: 1380px) {
                    &::after {
                        display: none;
                    }
                }
            }
            .work-addones {
                display: flex;
                flex-direction: column;
                font-size: 12px;
                color: #606060;
                margin-left: 14px;
                p {
                    line-height: 1;
                    margin-bottom: 7px;
                    &:last-child {
                        margin-bottom: 0;
                    }
                }
                @media (max-width: 1380px) {
                    & {
                        display: none;
                    }
                }
            }
        }
        .status {
            margin-left: 30px;
            font-size:16px;
            font-weight:400;
            color:#F15050;
            margin-right: 56px;
            .text {
                font-size:16px;
            }
        }
        .less {
            font-size:16px;
            color: #F15050;
            position: relative;
            .time {
                font-size:16px;
            }
            .time, .prompt {
                color: #F15050;
            }
            .prompt {
                font-size:12px;
                font-size: 12px;
                display: block;
                line-height: 1;
                position: absolute;
                bottom: 13px;
                width: 180px;
                width: max-content;
            }
        }
    }
    .right {
        float: right;
        height: 78px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/workbench-header.vue